"use strict";const a=require("./index8.js"),o=require("./index188.js");var e=a._export,r=o.arrayForEach;e({target:"Array",proto:!0,forced:[].forEach!==r},{forEach:r});
